export const isFetching = state => state.userPortals.fetching;
export const portals = state => state.userPortals.portals;
export const error = state => state.userPortals.error;
